import React from 'react';
import {Form, InputGroup} from 'react-bootstrap';
import TextareaAutosize from 'react-textarea-autosize';
import Autocomplete from './Autocomplete/Autocomplete.jsx';

export const renderField = ({input, label, placeholder, helptext,  type, meta: { touched, error, warning }, ...props}) => {
  let validate_class = '';
  let isValid = null;
  if (touched){
    if (error || warning) {
      validate_class = 'is-invalid';
      isValid = false;
    } else {
      validate_class = 'is-valid';
      isValid = true;
    }
  }

  let element = '';
  if (props.element && props.element === 'select'){
    element = <select {...input} placeholder={props.placeholder} className={'form-control' + ' ' + validate_class}>{props.children}</select>;
  } else if (props.element && props.element === 'auto_textarea') {
    element = <TextareaAutosize  {...input} ref={ props.inputRef } placeholder={placeholder} className={'form-control' + ' ' + validate_class} />;
  } else if (props.element && props.element === 'autocomplete') {
    element = <Autocomplete  {...input}
                             placeholder={placeholder}
                             suggestions={props.suggestions}
                             error={error}
                             className={'form-control' + ' ' + validate_class}
                             onSubmit={ props.onSubmit }
                             inputRef={ props.inputRef }/>;
  } else if (props.element && props.element === 'textarea') {
    element = <Form.Control as="textarea" placeholder={placeholder} {...input} isValid={touched && isValid} isInvalid={touched && !isValid}/>;
  } else if (props.element && props.element === 'checkbox') {
    element = <Form.Check type={type}
                          id={ props.id ? props.id : `id_${input.name}`}
                          label={props.componentLabel}
                          {...input}
                          checked={input.value ? 'checked' : ''}
                          isValid={touched && isValid}
                          isInvalid={touched && !isValid}/>
  } else if (props.element && props.element === 'file') {
    element = <input type="file" {...input} />
  } else {
    // element = <input {...input} placeholder={props.placeholder} type={type} className={'form-control' + ' ' + validate_class} />;
    element = <Form.Control type={type}
                            placeholder={placeholder}
                            disabled={ props.disabled }
                            {...input}
                            isValid={touched && isValid}
                            isInvalid={touched && !isValid}
                            className={ props.className }
                            readOnly={ props.readonly ? props.readonly : false }
                            ref={ props.inputRef }/>;
  }

  let feedback = '';
  if (touched && (error || warning)){
    feedback = <Form.Control.Feedback type="invalid">{error || warning}</Form.Control.Feedback>
  }

  if (props.simple) return element;
  let inputGroupAppend;
  if (props.inputGroupAppendText || props.inputGroupAppendButton){
    let inputGroupAppendChildren;
    if (props.inputGroupAppendText){
      inputGroupAppendChildren = <InputGroup.Text>{ props.inputGroupAppendText }</InputGroup.Text>;
    }
    if (props.inputGroupAppendButton){
      inputGroupAppendChildren = props.inputGroupAppendButton;
    }
    inputGroupAppend = <InputGroup.Append>{ inputGroupAppendChildren }</InputGroup.Append>
  }

  return (<>
    <Form.Group controlId={input.name + '_id'} bsPrefix={'form-group ' + validate_class}>
      { label ? <Form.Label>{label}{props.required ? ' *' : ''}</Form.Label> : '' }
      { props.withInputGroup && <InputGroup>
        { props.inputGroupPrepend && <InputGroup.Prepend><InputGroup.Text>{ props.inputGroupPrepend }</InputGroup.Text></InputGroup.Prepend> }
        { element }
        { inputGroupAppend }
      </InputGroup> }
      { !props.withInputGroup && element }
      { helptext ? <Form.Text className="text-muted">{helptext}</Form.Text> : '' }
      {/*<Form.Control.Feedback>Looks good!</Form.Control.Feedback>*/}
      { feedback }
    </Form.Group>
    </>
  )
};
